var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLmachineLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500.001,
    height: 500.001,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    fillRule: "evenodd",
    strokeLinecap: "square",
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10 0h55c5.523 0 10 4.477 10 10v70c0 5.523-4.477 10-10 10H10C4.477 90 0 85.523 0 80V10C0 4.477 4.477 0 10 0",
    style: {
      fill: "#4e3057",
      fillOpacity: 1
    },
    transform: "matrix(5.17225 0 0 5.17225 59.811 17.709)",
    fill: "#111"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M396.747 296.997c5.98-4.114 25.747 188.522 19.055 185.696l-199.44-31.109c-17.597 3.875-42.45 1.67-45.627-8.263L88.086 22.873c-4.05-11.32 189.354-20.93 186.45-9.262L242.06 355.076l154.686-58.08",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLmachineLogo);
export default __webpack_public_path__ + "static/media/lmachine-logo.c530c8dd4c97f53fe9f6d8789d67f5e6.svg";
export { ForwardRef as ReactComponent };